module.exports = __webpack_public_path__ + "img/2025-03-27-01-01.385980f8.png";